module.exports = __webpack_public_path__ + "img/process-05.d0ed911f.png";